import BottomSheetModal from '@/components/modules/modals/BottomSheetModal';
import Modal from '@/components/modules/modals/redesign/Modal/Modal';
import { classnames } from '@/helpers/general';
import useMobileView from '@/hooks/useMobileView';
import type { ReactNode } from 'react';

type InfoDrawerProps = {
  isOpen: boolean;
  onClose: () => void;

  title: string;

  /** Optional CTA row, rendered in the footer chrome below the content. */
  footer?: ReactNode;

  children: ReactNode;
};

/** Read-only detail drawer: a bottom sheet on mobile, a floating dark-header modal on desktop. */
const InfoDrawer = ({ isOpen, onClose, title, footer, children }: InfoDrawerProps) => {
  const { isMobileView } = useMobileView();

  if (isMobileView) {
    return (
      <BottomSheetModal isOpen={isOpen} onClose={onClose} title={title}>
        <div className="bg-surface_mp px-md py-md flex-1 overflow-y-auto min-h-[50vh]">{children}</div>
        {footer && <div className="px-md py-sm shrink-0">{footer}</div>}
      </BottomSheetModal>
    );
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose}>
      <Modal.Content floating newDesign contentMaxWidth={500}>
        <Modal.Header newDesign floating title={title} onClose={onClose} />
        <div className={classnames('bg-surface_mp px-md py-md', !footer && 'rounded-b-lg')}>{children}</div>
        {footer && <div className="px-md py-sm">{footer}</div>}
      </Modal.Content>
    </Modal>
  );
};

export default InfoDrawer;
